import PageWrapper from 'containers/AboutPage/styled/PageWrapper';
import { FooterWrapperFixed } from 'containers/styled';
import React, { useEffect } from 'react';
import { Router, useRouter } from 'next/router';
import { GetStaticProps } from 'next';

import Head from 'u9/components/Head';

import { AboutPageType } from 'types/aboutPage';
import { MenuItemsType } from 'types/menuItems';
import { CommonsType } from 'types/commons';

import { IndexPageProps } from 'containers/LandingPage';
import HeaderLogo from 'components/FilmPage/HeaderLogo';
import Footer from 'components/Footer';

import { aboutPageQuery, commonsQuery, indexQuery, menuQuery } from 'utils/gql';
import { cmsApiClient } from 'utils/api/cms';
import useDesktopMode from 'utils/hooks/useDesktopMode';
import theme from 'utils/theme';
import { ACTIONS, CATEGORIES, LABEL, Tracking } from 'utils/tracking';

import Menu from 'components/Menu';
import DescriptionWrapper from './styled/DescriptionWrapper';
import Description from './styled/Description';
import Background from './styled/Background';

export const getStaticProps: GetStaticProps = async context =>
  Promise.all([
    cmsApiClient.query({ query: indexQuery(context.locale) }),
    cmsApiClient.query({ query: aboutPageQuery(context.locale) }),
    cmsApiClient.query({ query: menuQuery(context.locale) }),
    cmsApiClient.query({ query: commonsQuery(context.locale) }),
  ]).then(([pageResults, aboutPageResult, menuResult, commonResult]) => ({
    props: {
      page: pageResults.data.indexPages[0],
      aboutPage: aboutPageResult.data.aboutPages[0],
      menu: menuResult.data.menuItems[0],
      commons: commonResult.data.commons[0],
    },
  }));

export type AboutProps = {
  page: IndexPageProps;
  aboutPage: AboutPageType;
  router: Router;
  menu: MenuItemsType;
  commons: CommonsType;
};

const AboutPage = ({
  aboutPage,
  page,
  router,
  menu,
  commons,
}: AboutProps): JSX.Element => {
  const lang = router.locale;
  const headProps = { ...page.head, lang };
  const { isDesktopMode } = useDesktopMode();

  useEffect(() => {
    Tracking.event({
      category: CATEGORIES.PageAbout,
      action: ACTIONS.PageAbout,
      label: LABEL.PageAbout,
    });
  }, []);

  return (
    <PageWrapper>
      <Head {...headProps} />
      <Menu light items={menu.items} />
      <HeaderLogo onClick={() => router.push('/')} />
      {isDesktopMode && <Background src={aboutPage.background.url} />}
      {!isDesktopMode && <Background src={aboutPage.backgroundMobile.url} />}
      <DescriptionWrapper>
        <Description
          dangerouslySetInnerHTML={{ __html: aboutPage.description }}
        />
      </DescriptionWrapper>
      <FooterWrapperFixed>
        <Footer
          line={!isDesktopMode}
          sticky
          copy={commons.footer}
          color={theme.colors.primary.light}
        />
      </FooterWrapperFixed>
    </PageWrapper>
  );
};

export default AboutPage;
